module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/workspaces/v20220421/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/workspaces/v20220421/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}